module.exports = __webpack_public_path__ + "media/images/mailer/facebook-light-ca849f1f3dd3b2507cddac6f4bfe8227.png";